// ===========================================================================
// Consultas al médico (physician queries de Charge Capture) — store local.
//
// CONCEPCION_PROTOTIPO_CHARGE_CAPTURE.md §8.5: el indicador de consultas
// pendientes debe ser EL MISMO que el de notas sin firmar de CDCI — dos
// contadores compitiendo por atención equivalen a cero contadores. Por eso
// este store vive en el kit de alertas (como pendingNotesStore) y el panel de
// la campana lo lee junto a lo demás.
//
// TODO(backend): cuando exista la tabla de queries, este store se reemplaza
// por el endpoint real manteniendo la forma de retorno.
// ===========================================================================

const STORAGE_KEY = "mcm_cc_physician_queries.v1";

/** Evento de ventana disparado en cada cambio del store. */
export const PHYSICIAN_QUERIES_EVENT = "mcm:physician-queries-changed";

const read = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const write = (list) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch {
    // Storage bloqueado: el aviso vive solo en memoria esta sesión.
  }
  try {
    window.dispatchEvent(new Event(PHYSICIAN_QUERIES_EVENT));
  } catch {
    // Sin window (tests).
  }
};

/**
 * Consultas al médico ABIERTAS (pendientes de respuesta), la más vieja primero
 * — la más vieja es la que está por vencer el SLA.
 *
 * @returns {Array<{queryId:string, caseId:string, physician:string,
 *   patientName:string, type:string, openedAt:string}>}
 */
export const getOpenPhysicianQueries = () =>
  read().sort((a, b) => String(a.openedAt || "").localeCompare(String(b.openedAt || "")));

/** Registra (o reemplaza, por queryId) una consulta abierta. */
export const addPhysicianQuery = (q) => {
  const record = {
    queryId: String(q.queryId),
    caseId: String(q.caseId),
    physician: q.physician || "—",
    patientName: q.patientName || "—",
    type: q.type || "",
    openedAt: q.openedAt || new Date().toISOString(),
  };
  write([record, ...read().filter((x) => x.queryId !== record.queryId)]);
  return record;
};

/** Quita una consulta del store (respondida o resuelta). */
export const removePhysicianQuery = (queryId) => {
  write(read().filter((x) => x.queryId !== String(queryId)));
};
